module.exports = __webpack_public_path__ + "static/media/head.2d0c92fd.svg";